import { AuditItem } from '@cdab/scania/qpr/components/atoms'
import { TdsButton } from '@scania/tegel-react'
import styled from 'styled-components'

export const StyledPledgeItem = styled(AuditItem)`
  background-color: ${props =>
    props.selected ? 'var(--tds-grey-250)' : 'var(--tds-grey-150)'};
  &:hover {
    background-color: ${props =>
      props.selected ? 'var(--tds-grey-300)' : 'var(--tds-grey-200)'};
  }
`
export const StyledFlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`

export const StyledTdsButton = styled(TdsButton)`
  &&& {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    button {
      display: block;
    }
  }
`
